<template>
  <div class="app-shell">
    <Preloader @complete="onPreloaderComplete" />
    <VideoLayer src="/videos/hero-bg.mp4" blendMode="screen" :opacity="0.1" />
    <div class="noise-overlay"></div>
    <CustomCursor />
    <HomeView />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HomeView from "./views/HomeView.vue";
import VideoLayer from "./components/VideoLayer.vue";
import CustomCursor from "./components/CustomCursor.vue";
import Preloader from "./components/Preloader.vue";

gsap.registerPlugin(ScrollTrigger);

let lenis;

function onPreloaderComplete() {
  if (lenis) {
    lenis.start();
    document.documentElement.style.overflow = "";
  }
}

onMounted(() => {
  lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: "vertical",
    smoothWheel: true,
  });

  lenis.stop();

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);
});

onUnmounted(() => {
  if (lenis) {
    lenis.destroy();
    lenis = null;
  }
});
</script>

<style scoped>
.app-shell {
  position: relative;
  min-height: 100vh;
  cursor: none;
}

@media (pointer: coarse) {
  .app-shell {
    cursor: auto;
  }
}
</style>

<style>
.video-layer--global {
  position: fixed;
  z-index: 0;
}
</style>
